import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-hold-to-confirm-button',
  templateUrl: './hold-to-confirm-button.component.html',
  styleUrls: ['./hold-to-confirm-button.component.scss']
})
export class HoldToConfirmButtonComponent {
  @Input()
  icon = 'update';

  @Input()
  holdTime = 2000;

  @Input()
  maxTime = 2500;

  @Input()
  title = 'Hold to confirm';

  /**
   * Disables the button, which then never confirms: for a user who lacks the
   * permission the action needs (issue #620).
   */
  @Input()
  public disabled = false;

  @Output()
  public confirmed = new EventEmitter<void>();

  pressing = false;
  /** Set once this press confirms, so that a press confirms once. */
  private confirmedThisPress = false;

  progress = 0;

  constructor(
  ) {
  }

  onLongPress() {
    if (this.disabled) {
      return;
    }
    this.pressing = true;
  }

  onLongPressing(timeLapsed: number) {
    if (this.disabled) {
      return;
    }
    this.pressing = true;
    this.progress = 10 + 100 * (timeLapsed / this.holdTime);
    if (!this.confirmedThisPress && timeLapsed >= this.holdTime) {
      this.confirmed.emit();
      this.confirmedThisPress = true;
    }
  }

  onReleasePressing() {
    this.pressing = false;
    this.progress = 0;
    this.confirmedThisPress = false;
  }
}

